/***
**Module Name: client
 **File Name :  client.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains clients table details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import tmdbApi from "../../api/tmdbApi";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import TableLoader from "../../components/tableLoader";

import { contentContext } from "../../context/contentContext";
import { keyActivate } from "../../utils/a11y";
import SweetAlert from 'react-bootstrap-sweetalert';
import SessionPopup from "../SessionPopup"
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

let { lambda, country, appname } = window.app;


const Client = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    // const [toggle, setToggle] = useState(false);
    const [content, setContent] = useState("");
    const [perpage, setPerpage] = useState(10);
    const [loaderEnable, setLoaderEnable] = useState(false);
    // const [data, setData] = useState([]);



    const [countries, setCountries] = useState('');
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [image, setImg] = useState('');
    const [flag, setFlag] = useState(false);
    // const [isLoading, setIsLoading] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);

    const [popup, setShowPopup] = useState(false);
    const [clientId, setClientId] = useState("");
    const [isDelete, setIsDelete] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false);

    const [showSessionPopupup, setShowSessionPopupup] = useState(false);

    const handleClosePopup = () => setShowPopup(false);
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();

    const [subscriptionsData, setSubscriptionsData] = useState([]);



    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, sortTableAlpha, arrow, sortTableByDate, userData, clientmanagesearch, setClientMangeSearch, clientAdvSearch, setClientAdvSearch, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setActiveMenuObj, activeMenuObj, processObject, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Client Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].submenus && validateObj[0].submenus[0] && validateObj[0].submenus[0].dashboard
    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setClientAdvSearch({})
            setSearchedFlag(false);
            setClientMangeSearch("");
        }

    }, [prevRoute]);


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imagesCDN) {
                    setImg(window.site.common.imagesCDN)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imagesCDN) {
            setImg(window.site.common.imagesCDN)
        }

    }, [window.site]);
    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    const columns = [

        {
            name: 'Business Name',
            selector: row => row?.businessname ?? "",
            sortable: true,
            grow: 2,
        },
        {
            name: 'Subscription',
            selector: row => row?.subscription ?? "",
            sortable: true,
            minWidth: '130px',
        },
        {
            name: 'Email ID',
            selector: row => row?.emailId ?? "",
            sortable: true,
            minWidth: '230px',
        },
        {
            name: 'Phone Number',
            selector: row => row?.phone ?? "",
            sortable: true,
            minWidth: '130px',
        },
        {
            name: 'Created On',
            selector: row => row?.created,
            sortable: true,
            cell: (props) => props.created ? moment.utc(props.created).format("MM-DD-YYYY") : "",
            width: '115px',
        },
        {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
            width: '120px',
        },
        {
            name: 'Actions',
            cell: (props) =>
                <div className="d-flex">
                    <a onClick={e => handleViewClient(e, props.clientid)}
                        onKeyDown={keyActivate(e => handleViewClient(e, props.clientid))}
                        className="text-success action-button"
                    ><i className="mdi mdi-eye font-size-18"></i></a>
                    <a onClick={e => handleEditClient(e, props.clientid)} style={{ position: "inherit" }}
                        onKeyDown={keyActivate(e => handleEditClient(e, props.clientid))}
                        className="text-danger action-button"
                    ><i className="mdi mdi-pencil font-size-18"></i></a>
                    <a style={{ position: "inherit" }}
                        onClick={() => handleDelete(props?.clientid)}
                        onKeyDown={keyActivate(() => handleDelete(props?.clientid))}
                        className={`text-danger action-button ${localStorage.getItem("clientid") === props?.clientid || props?.status === "ARCHIVE" ? "pe-none" : ""}`}
                        id="client-delete-icon"><i className="mdi mdi-delete font-size-18"></i></a>
                </div>,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '110px',
        },
    ];

    const getSbscriptionsApi = (e) => {
        axios({
            method: 'GET',
            url: lambda + '/getSubscriptions?appname=' + appname,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    // setShowSessionPopupup(true)
                } else {
                    setSubscriptionsData(response?.data?.result);
                    //setSelectedPlan("basic plan")


                }

            }).catch((err) => {
                console.log('error', err);

            });
    }
    const handlePageChange = (page) => {
        GetTimeActivity()
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()
        setRowsPerPage(newPerPage);
    };

    const handleShowPopup = () => {
        GetTimeActivity()
        setShowPopup(true);
        getSbscriptionsApi();
    };

    const handleClick = (event) => {
        GetTimeActivity()
        setCurrentPage(Number(event.target.id));
    };


    // console.log('subValDashboard obj',subValDashboard)
    // const handleEditClient = (e,id) => {  
    //     navigate("/editclient/" + id);
    //  }

    const pages = [];
    for (let i = 1; i <= Math.ceil(content.totalClients / itemsPerPage); i++) {
        pages.push(i);
    }





    useEffect(() => {

        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setRoute("client")
        setActiveMenuId(300001)

        setActiveMenuObj({
            "Client Management": true,
            "Contact Management": false,
            "Reports": false
        })
        // if (search === true) {
        //     handleSearch();

        // } else {
        //     client();
        //   //   GetCountries();
        // }
        // userActivity();

    }, []);


    // console.log('datataatatatta',data)

    const handleExport = () => {
        //    console.log('exportExcelData',global.exportExcelData)
        // let k = defaultData || exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "BUSINESS NAME": each?.businessname ?? "",
            "Subscription": each?.subscription ?? "",
            "EMAIL": each?.emailId ?? "",
            "PHONE NUMBER": each?.phone ?? "",
            // "ACCOUNT MANAGER": each?.companydetails?.[0]?.accountmanager ?? "",
            // "ENTITY": each?.entity,
            "CREATED ON": each?.created ? new Date(each?.created).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',

            }) : "",
            "STATUS": each?.status ?? "",
        }));

        exportToExcel(modifiedArray, "data");

    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data, `ClientsData.xlsx`);
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators

            const aField = String(selector(rowA)).toLowerCase();
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // setSortedData2(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        let presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }
    useEffect(() => {


        console.log("trueeeeeeeeee", searchedFlag);
        if (searchedFlag) {
            console.log("came")
            handleSearch();
        } else {
            console.log("called get all deals")
            client();
            //   GetCountries();
        }

    }, [searchedFlag]);
    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                "projection": "tiny"
            });


            setCountries(response?.result.data);
        } catch {
            console.log("error");
        }
    };

    const client = (e) => {
        console.log('client call')
        GetTimeActivity()
        let page = 1;
        //  setCurrentPage(1);
        setIsLoading(true);
        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")

        axios({
            method: 'POST',
            url: lambda + '/clients?appname=' + appname + "&userid=" + userid,
        })
            .then(function (response) {
                // console.log("response", response?.data?.result?.data);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setData(response?.data?.result?.data);
                    global.exportExcelData = response?.data?.result?.data


                    setContent(response?.data?.result);
                    setIsLoading(false);
                    setClientMangeSearch("");
                    setSearchedFlag(false);
                }

            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }




    const handleAdd = () => {
        GetTimeActivity()
        navigate("/addclient")
    }
    const handleSearch = (e, flagggg) => {
        GetTimeActivity()
        setLoaderEnable(true)


        setFlag(true)
        if (flagggg === "normalsearch" || flagggg === "click") {
            setSearchedFlag(true)
        }

        if (clientmanagesearch === "" && clientAdvSearch.length <= 0) {
            client();
        }

        else {
            console.log('handle search')
            const token = localStorage.getItem("token")
            const userid = localStorage.getItem("userId")
            if (flagggg === "normalsearch") {
                setIsLoading(true)
            }
            let urlLink;

            urlLink = `${lambda}/clients?appname=${appname}&userid=${userid}${clientmanagesearch ? `&search=${clientmanagesearch}` : ''}`;

            // urlLink = lambda + '/clients?appname=' + appname + "&token=" + token + "&userid=" + userid

            // let payload = clientmanagesearch ? { search: clientmanagesearch, ...clientAdvSearch } : { ...clientAdvSearch };

            // const result = processObject(clientAdvSearch);
            // setClientAdvSearch(result)
            axios({
                method: 'POST',
                url: urlLink,
                // data: payload,
                // data: result,
            })
                .then(function (response) {
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        setIsLoading(false)
                        setShowPopup(false)
                    } else {
                        // console.log("response", response);
                        setData(response?.data?.result?.data);
                        global.exportExcelData = response?.data?.result?.data
                        setContent(response?.data?.result);
                        setIsLoading(false);
                        setShowPopup(false)
                        setLoaderEnable(false);
                        if (flagggg === "click") {
                            setClientMangeSearch("")
                        }
                    }
                }).catch((err) => {
                    console.log('error', err);
                    setTableErrMsg(true)
                    setIsLoading(false);
                });
        }
    }

    const handleChange = (e) => {
        if (e.target.value === "") {
            //client();
            setFlag(false)
        }
        setClientMangeSearch(e.target.value)
    }

    const handleKeypress = (e) => {
        GetTimeActivity()
        //it triggers by pressing the enter key

        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 1000);
        }
    };

    const handleEditClient = (e, paramuserid) => {
        console.log('paramuserid', paramuserid)
        GetTimeActivity()
        navigate("/editclient/" + paramuserid);
    }
    const handleViewClient = (e, paramuserid) => {
        GetTimeActivity()
        navigate("/viewclient/" + paramuserid);
    }

    const handleDelete = (Id) => {
        setClientId(Id);
        setIsDelete(true);
    }
    const handleCancel = () => {
        setIsDelete(false);
    }
    const handleClose = () => {
        setIsDelete(false);
    }
    const handleDeleteClient = () => {
        GetTimeActivity()
        setDeleteLoader(true)
        const userid = localStorage.getItem("userId")
        const token = localStorage.getItem("token")
        axios.post(lambda + '/updateClient?appname=' + appname + '&userId=' + userid + '&token=' + token + '&clientid=' + clientId, { status: "ARCHIVE" })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        client()
                        setDeleteLoader(false)
                        setIsDelete(false)
                    }
                }
            }).catch((err) => {
                console.log('errr', err)
                setDeleteLoader(false)
            });
    }

    const clearSearch = () => {
        GetTimeActivity()
        setClientMangeSearch("");
        setClientAdvSearch({})
        client();
    }

    const clearadvSearch = () => {
        GetTimeActivity()
        setClientAdvSearch({ ...clientAdvSearch, name: "", personalemail: "", idc: "+91", personalphone: "", type: "", entity: "", accountmanager: "", created: "", status: "" })
    }
    const handleAdvChange = (e) => {
        GetTimeActivity()
        setClientAdvSearch({ ...clientAdvSearch, [e.target.name]: e.target.value });
    }


    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No clients were found</p>
                </div> </div>
        )
    }


    // console.log("current page", currentPageNew);
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header id="header" />
                <Sidebar id="sidebar" />

                <div className="main-content user-management clients" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">CLIENTS</h4>
                                        </div>
                                        <div>
                                            <button onClick={handleAdd} className="fill-btn-style" id="add-client-btn">
                                                ADD CLIENT
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                            <div className="row mb-2" id="table-header-row">
                                                <div className="col-sm-4 button-block" id="button-block">
                                                    <div className="dataTables_length" id="datatable-length">
                                                        <button
                                                            className={`fill_btn ${data.length <= 0 ? 'disable pe-none' : ''}`}
                                                            onClick={handleExport}
                                                            id="export-btn">
                                                            <span className="material-icons">north_east</span>Export
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-sm-8">
                                                    <div className="search-box mb-2 d-inline-block" id="search-box">
                                                        <div className="position-relative">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={clientmanagesearch}
                                                                onChange={(e) => handleChange(e)}
                                                                onKeyPress={handleKeypress}
                                                                placeholder="Search by Name or Email"
                                                                id="search-input"
                                                            />
                                                            <button
                                                                className="fill_btn"
                                                                onClick={(e) => handleSearch(e, "normalsearch")}
                                                                id="search-btn">
                                                                <span className="material-icons search-icon">search</span>
                                                            </button>
                                                        </div>
                                                        {/* <div className="dataTables_length" id="datatable-length-reset">
                                                            <button className="fill_btn" onClick={handleShowPopup} id="advanced-search-btn">
                                                                Advanced Search
                                                            </button>
                                                        </div> */}
                                                        <div className="dataTables_length" id="datatable-length-reset">
                                                            <button
                                                                className="fill_btn"
                                                                onClick={clearSearch}
                                                                id="reset-btn">
                                                                <span className="material-icons-outlined">sync</span>Reset
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <DataTable
                                                key={keyForRerender}
                                                columns={columns}
                                                keyField='_id'
                                                data={data}
                                                direction="auto"
                                                highlightOnHover
                                                fixedHeaderScrollHeight="300px"
                                                pagination
                                                responsive
                                                persistTableHead
                                                striped
                                                subHeaderAlign="right"
                                                defaultSortField="name"
                                                noDataComponent={customNoRecords()}
                                                paginationTotalRows={data.length}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                paginationPerPage={rowsPerPage}
                                                paginationDefaultPage={currentPageNew}
                                                paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                sortFunction={customSort}
                                                paginationComponentOptions={{
                                                    rowsPerPageText: 'Per page:',
                                                    rangeSeparatorText: 'of',
                                                    noRowsPerPage: false,
                                                    selectAllRowsItem: false,
                                                    selectAllRowsItemText: 'All',
                                                }}
                                                progressPending={isLoading}
                                                progressComponent={<TableLoader />}
                                                id="data-table"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <Modal
                        className="advance-search search-popup client-advance-search"
                        show={popup}
                        onHide={handleClosePopup}
                        backdrop="static"
                        id="advanced-search-modal">
                        <Modal.Header closeButton id="advanced-search-modal-header">
                            <Modal.Title id="advanced-search-modal-title">Advanced Search</Modal.Title>
                        </Modal.Header>
                        <Modal.Body id="advanced-search-modal-body">
                            <div className="row" id="advanced-search-row">
                                <div className="col-md-6" id="name-field">
                                    <div className="input-field" id="name-input">
                                        <label className="col-form-label" id="name-label">NAME</label>
                                        <input
                                            className="form-control"
                                            placeholder="Enter Name"
                                            type="text"
                                            name="name"
                                            value={clientAdvSearch.name}
                                            onChange={(e) => handleAdvChange(e)}
                                            id="name-input-field"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6" id="email-field">
                                    <div className="input-field" id="email-input">
                                        <label className="col-form-label" id="email-label">EMAIL</label>
                                        <input
                                            className="form-control contact-number"
                                            name="personalemail"
                                            type="email"
                                            placeholder="Enter Email"
                                            value={clientAdvSearch.personalemail}
                                            onChange={(e) => handleAdvChange(e)}
                                            id="email-input-field"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6" id="contact-number-field">
                                    <div className="input-field" id="contact-number-input">
                                        <label className="col-form-label" id="contact-label">CONTACT NUMBER</label>
                                        <div className="country-code">
                                            <select
                                                name="idc"
                                                className="colorselect capitalize"
                                                value={clientAdvSearch.idc}
                                                onChange={(e) => handleAdvChange(e)}
                                                id="country-code-select"
                                            >
                                                <option value="US(+1)">US(+1)</option>
                                                {countries && countries?.length > 0 && countries?.map((task, i) => (
                                                    <option key={i} value={task.alpha3}>
                                                        {task.alpha3 + task.countrycode}
                                                    </option>
                                                ))}
                                            </select>

                                            <input
                                                className="form-control contact-number"
                                                type="tel"
                                                name="personalphone"
                                                placeholder="Enter Phone Number"
                                                value={clientAdvSearch.personalphone}
                                                onChange={(e) => handleAdvChange(e)}
                                                maxLength="10"
                                                id="phone-input"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6" id="type-field">
                                    <div className="input-field" id="type-input">
                                        <label className="col-form-label" id="type-label">TYPE</label>
                                        <select
                                            className="form-select"
                                            name="type"
                                            value={clientAdvSearch.plan}
                                            onChange={(e) => handleAdvChange(e)}
                                            id="type-select"
                                        >
                                            <option value="">Select Plans</option>
                                            {subscriptionsData && subscriptionsData?.map((plan) => (
                                                <option value={plan?.planname && plan?.planname?.toLowerCase()}>{plan?.planname}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6" id="created-on-field">
                                    <div className="input-field" id="created-on-input">
                                        <label className="col-form-label" id="created-on-label">Created On</label>
                                        <input
                                            id="created-on-date"
                                            name="created"
                                            placeholder="mm-dd-yyyy"
                                            type="date"
                                            className="form-control"
                                            value={clientAdvSearch.created}
                                            onChange={(e) => handleAdvChange(e)}
                                            max={new Date().toISOString().split('T')[0]}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6" id="status-field">
                                    <div className="input-field" id="status-input">
                                        <label className="col-form-label" id="status-label">Status</label>
                                        <select
                                            className="form-select"
                                            name="status"
                                            value={clientAdvSearch.status}
                                            onChange={(e) => handleAdvChange(e)}
                                            id="status-select"
                                        >
                                            <option value="">Select Status</option>
                                            <option value="PENDING APPROVAL">Pending Approval</option>
                                            <option value="PENDING VERIFICATION">Pending Verification</option>
                                            <option value="PENDING TERMS">Pending Terms</option>
                                            <option value="INACTIVE">Inactive</option>
                                            <option value="ACTIVE">Active</option>
                                            <option value="REJECT">Reject</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer id="modal-footer">
                            <div className="adv_footer" id="advanced-footer">
                                <button
                                    className="fill_btn yellow-gradient reset-btn"
                                    onClick={clearadvSearch}
                                    id="reset-adv-search-btn">
                                    <span className="material-icons-outlined">sync</span>Reset
                                </button>

                                <button
                                    onClick={(e) => handleSearch(e, "click")}
                                    id="adv-search-btn">
                                    {loaderEnable ? (
                                        <img
                                            src={image + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                                            className="loading-icon"
                                            alt="loading"
                                        />
                                    ) : null}
                                    SEARCH
                                </button>

                                <div className="clearfix"></div>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title="Something went wrong. Please reload again."
                        onConfirm={() => setTableErrMsg(false)}
                        id="sweet-alert"
                    />

                    <Modal className="access-denied" show={isDelete}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content rounded-4">
                                <div className="modal-header border-0 justify-content-center position-relative">
                                    <button className="close-btn" onClick={handleClose} id="client-delete-close-btn">
                                        <span className="material-icons">close</span>
                                    </button>
                                </div>
                                <div className="modal-body enquiry-form text-center" id="client-delete-body">
                                    <span className="material-icons access-denied-icon" style={{ fontSize: '48px', color: '#dc3545' }}>delete_forever</span>
                                    <h3 className="modal-sm-heading mt-2" id="client-delete-title">Delete Client</h3>
                                    <p className="modal-text" id="client-delete-text">
                                        This action cannot be undone.<br />
                                        Do you want to delete this client?
                                    </p>
                                </div>
                                <div className="modal-footer border-0 justify-content-center gap-3 pb-4">
                                    <button className="fill_btn" onClick={handleCancel} id="client-dont-delete-btn">
                                        Cancel
                                    </button>
                                    <button className="fill_btn yellow-gradient" onClick={handleDeleteClient} id="client-confirm-delete-btn">
                                        {deleteLoader ? (
                                            <img
                                                src={image + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                                                className="loading-icon"
                                                alt="Loading"
                                            />
                                        ) : null}
                                        Yes, Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Footer id="footer" />
                </div>
            </div>

        </>
    );
};

export default Client;
